import { useRoute } from 'react-router5';
import { RouterState } from '../routerMiddleware';

export default function useVacancyCount(): boolean {
  const { route } = useRoute();
  const state = route as RouterState;

  return state?.data?.vacancyCount > 0;
}
